import { Dispatch } from "redux";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { setOrganizations, setOrganizationsLoading } from "@redux/actions/organizations-actions";
import { getAxnCompaniesRequest } from "@requests/axnadmin-core";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getOrganizationsReduxRequest = (dispatch: Dispatch) => async (): Promise<Array<AxnCompany>> => {
    dispatch(setOrganizationsLoading(true));
    const { data, error } = await getAxnCompaniesRequest();
    if (data?.axnCompanies) {
        dispatch(setOrganizations(data.axnCompanies));
        return data.axnCompanies;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getOrganizations.error.title,
                resources.requests.getOrganizations.error.message
            );
        }
        dispatch(setOrganizationsLoading(false));
        return null;
    }
};